import List from 'components/List'
import FontAwesome from 'react-fontawesome'
import Panel from 'components/Panel'

const RecentTopics = ({ topics, renderItemList, height }) => {
  const icon = <FontAwesome name="clock-o" />
  return (
    <Panel title="My Recent" blue buttons={icon} height={height}>
      {topics.length === 0 && (
        <div className="no-content">You don't have any recents.</div>
      )}

      {topics.length !== 0 && (
        <List>
          {renderItemList(topics, { showType: true, showDevice: true })}
        </List>
      )}
    </Panel>
  )
}

export default RecentTopics
